import { VStack } from '@sgme/ui';
import type { ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

function reload() {
  window.location.reload();
}
const email = 'sg-markets@sgcib.com';

export function SessionEndedModal(): ReactElement {
  return (
    <Modal show backdrop="static" contentClassName="border border-danger">
      <Modal.Header>
        <VStack>
          <div
            className="d-flex align-items-center justify-content-center bg-danger bg-opacity-10 rounded-circle mb-4"
            style={{ width: 48, height: 48 }}
          >
            <i className="icon icon-md text-danger">power_off</i>
          </div>
          <h4 className="text-danger">
            <FormattedMessage id="fatal.sessionEndedModal.title" />
          </h4>
        </VStack>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-16px">
        <p className="text-secondary">
          <FormattedMessage id="fatal.sessionEndedModal.reason" />
        </p>
        <p>
          <FormattedMessage
            id="fatal.sessionEndedModal.assistance"
            values={{ email: <a href={`mailto:${email}`}>{email}</a>, br: <br /> }}
          />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-default" onClick={reload}>
          <FormattedMessage id="fatal.sessionEndedModal.footer.button" />
        </button>
      </Modal.Footer>
    </Modal>
  );
}
